import NotificationCard from './NotificationCard'
import NotificationCardLoading from './NotificationCardLoading'
import NotificationCardMobile from './NotificationCardMobile'
import NotificationCardMobileLoading from './NotificationCardMobileLoading'

export {
  NotificationCardLoading,
  NotificationCardMobile,
  NotificationCardMobileLoading,
}
export default NotificationCard
